import axios, {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse,
} from 'axios'

import { EXPIREDTOKEN, INNER_STORE, INVALIDTOKEN } from './constants'
import { get } from './inner-store'
import { refresh } from './refresh'
import { refreshOnTime } from './refresh-on-time'

const responseErrorInterceptor = async (
  error: AxiosError<any>,
): Promise<AxiosResponse> => {
  // Any status codes that falls outside the range of 2xx cause this function to trigger
  // Do something with response error

  if (error.response && error.response.status === 401) {
    if (
      error.response.data &&
      error.response.data.error === 'invalid_token' &&
      error.response.data.error_description ===
        'Token verification failed'
    ) {
      const reqConfig = await refreshFlow(error)
      const axiosInstance = axios.create({
        withCredentials: true,
      })
      return await axiosInstance.request(reqConfig)
    }

    if (error.response.data?.errors) {
      for await (const err of error.response.data.errors) {
        if (err.code === EXPIREDTOKEN || err.code === INVALIDTOKEN) {
          const reqConfig = await refreshFlow(error)
          const axiosInstance = axios.create({
            withCredentials: true,
          })
          return await axiosInstance.request(reqConfig)
        }
      }
    }
  }

  return await Promise.reject(error)
}

const refreshFlow = async (
  error: AxiosError<any, any>,
): Promise<AxiosRequestConfig<any>> => {
  const refreshAuthData = await refresh()

  const autoRefresh = get(INNER_STORE.autoRefresh)
  const cancelRefreshOnTime = get(INNER_STORE.cancelRefreshOnTime)

  if (autoRefresh && cancelRefreshOnTime !== undefined) {
    // se cancela el ciclo de auto refresco actual y se inicia uno nuevo
    cancelRefreshOnTime()
    refreshOnTime()
  }

  error.config.headers = {
    ...error.config.headers,
    ...{
      Authorization: `Bearer ${refreshAuthData.access_token}`,
    },
  }

  return error.config
}

export { responseErrorInterceptor }
